export const GET_LIST_PROMO_GROUP_REQUEST = 'GET_LIST_PROMO_GROUP_REQUEST'
export const GET_LIST_PROMO_GROUP_SUCCESS = 'GET_LIST_PROMO_GROUP_SUCCESS'
export const GET_LIST_PROMO_GROUP_FAIL = 'GET_LIST_PROMO_GROUP_FAIL'

export const GET_DETAIL_PROMO_GROUP_REQUEST = 'GET_DETAIL_PROMO_GROUP_REQUEST'
export const GET_DETAIL_PROMO_GROUP_SUCCESS = 'GET_DETAIL_PROMO_GROUP_SUCCESS'
export const GET_DETAIL_PROMO_GROUP_FAIL = 'GET_DETAIL_PROMO_GROUP_FAIL'

export const CREATE_PROMO_GROUP_REQUEST = 'CREATE_PROMO_GROUP_REQUEST'
export const CREATE_PROMO_GROUP_SUCCESS = 'CREATE_PROMO_GROUP_SUCCESS'
export const CREATE_PROMO_GROUP_FAIL = 'CREATE_PROMO_GROUP_FAIL'

export const UPDATE_PROMO_GROUP_REQUEST = 'UPDATE_PROMO_GROUP_REQUEST'
export const UPDATE_PROMO_GROUP_SUCCESS = 'UPDATE_PROMO_GROUP_SUCCESS'
export const UPDATE_PROMO_GROUP_FAIL = 'UPDATE_PROMO_GROUP_FAIL'

export const DELETE_PROMO_GROUP_REQUEST = 'DELETE_PROMO_GROUP_REQUEST'
export const DELETE_PROMO_GROUP_SUCCESS = 'DELETE_PROMO_GROUP_SUCCESS'
export const DELETE_PROMO_GROUP_FAIL = 'DELETE_PROMO_GROUP_FAIL'

export const GET_PROMO_GROUP_TRANSACTIONS_REQUEST = 'GET_PROMO_GROUP_TRANSACTIONS_REQUEST'
export const GET_PROMO_GROUP_TRANSACTIONS_SUCCESS = 'GET_PROMO_GROUP_TRANSACTIONS_SUCCESS'
export const GET_PROMO_GROUP_TRANSACTIONS_FAIL = 'GET_PROMO_GROUP_TRANSACTIONS_FAIL'

export const EXPORT_PROMO_GROUP_REQUEST = 'EXPORT_PROMO_GROUP_REQUEST'
export const EXPORT_PROMO_GROUP_SUCCESS = 'EXPORT_PROMO_GROUP_SUCCESS'
export const EXPORT_PROMO_GROUP_FAIL = 'EXPORT_PROMO_GROUP_FAIL'

export const GET_LIST_EXPORT_PROMO_GROUP_REQUEST = 'GET_LIST_EXPORT_PROMO_GROUP_REQUEST'
export const GET_LIST_EXPORT_PROMO_GROUP_SUCCESS = 'GET_LIST_EXPORT_PROMO_GROUP_SUCCESS'
export const GET_LIST_EXPORT_PROMO_GROUP_FAIL = 'GET_LIST_EXPORT_PROMO_GROUP_FAIL'

export const DOWNLOAD_EXPORT_PROMO_GROUP_REQUEST = 'DOWNLOAD_EXPORT_PROMO_GROUP_REQUEST'
export const DOWNLOAD_EXPORT_PROMO_GROUP_SUCCESS = 'DOWNLOAD_EXPORT_PROMO_GROUP_SUCCESS'
export const DOWNLOAD_EXPORT_PROMO_GROUP_FAIL = 'DOWNLOAD_EXPORT_PROMO_GROUP_FAIL'
